module.exports = __webpack_public_path__ + "img/facebook.ab619c32.png";